module.exports = __webpack_public_path__ + "static/media/a.213f68f3.jpg";